import React, { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useCustomer } from '@hooks/useCustomer';
import { CUSTOMER_GROUP_CONFIG } from '@components/tradeRoute/tradeRoute.constants';

export interface iTradeRouteProps {
  children: (isPageAvailable: boolean, userVariant: tUserVariant, loadingCustomer: boolean) => React.ReactNode;
  onPageAvailable: () => void;
}

export enum eUserVariants {
  GUEST = 'GUEST',
  REGULAR = 'REGULAR',
  TRADE = 'TRADE',
}

export type tUserVariant = eUserVariants.GUEST | eUserVariants.REGULAR | eUserVariants.TRADE;

export const TradeRoute = ({ children, onPageAvailable }: iTradeRouteProps) => {
  const router = useRouter();
  const { loadingCustomer, isAuthed, customer } = useCustomer();
  const isTradeMember = customer?.customerGroupId === CUSTOMER_GROUP_CONFIG.TRADE_MEMBER_ID;
  const [isPageAvailable, setIsPageAvailable] = useState(() => isAuthed && isTradeMember);
  const [userVariant, setUserVariant] = useState<tUserVariant>(eUserVariants.GUEST);
  const hasParams = router.asPath?.includes('?');

  useEffect(() => {
    if (!loadingCustomer) {
      if (!isAuthed) {
        setIsPageAvailable(false);
        setUserVariant(eUserVariants.GUEST);
      } else {
        if (!isTradeMember) {
          setIsPageAvailable(false);
          setUserVariant(eUserVariants.REGULAR);
        } else {
          setIsPageAvailable(true);
          setUserVariant(eUserVariants.TRADE);
          !hasParams && onPageAvailable();
        }
      }
    }
  }, [loadingCustomer, isAuthed, customer]);

  return <Fragment>{children(isPageAvailable, userVariant, loadingCustomer)}</Fragment>;
};
